var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',[_c('v-container',[_c('router-view',{on:{"snackbarevent":_vm.updateSnackbar}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }